import React from 'react';
import Page from '../components/Page';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
} from 'reactstrap';
import axios from 'axios';
import StorageService from '../services/StorageService';
import {
  MdCameraAlt,
  MdFace,
  MdDone,
  MdClear,
  MdCreate,
  MdFiberManualRecord,
} from 'react-icons/md';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Redirect } from 'react-router';
import Avatar from '../components/Avatar';
import userImage from '../assets/img/users/profile.jpg';
import ConfirmDeleteModal from '../components/ConfirmDeleteModal';

class UserPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      email: '',
      name: '',
      contact: '',
      role: '',
      isEdit: false,
      userId: '',
      userList: [],
      roleList: [],
      redirect: false,
      isConfirmDelete: false,
      selectedItem: '',
      search: ''
    };
  }

  confirmDeleteToggle = (data) => () => {
    return this.setState({
        isConfirmDelete: !this.state.isConfirmDelete,
        selectedItem: data
    });
  };

  toggle = (action, id) => () => {
    let obj = {};

    if (id !== undefined || id !== null) {
      obj = this.state.userList.find(e => e.ProfileID === id);
    }

    return this.setState({
      modal: !this.state.modal,
      isEdit:
        id != undefined || (id != null && action == 'EDIT') ? true : false,
      userId: id != undefined || (id != null && action == 'EDIT') ? id : '',
      email:
        id != undefined || (id != null && action == 'EDIT') ? obj.Email : '',
      name: id != undefined || (id != null && action == 'EDIT') ? obj.Name : '',
      contact:
        id != undefined || (id != null && action == 'EDIT') ? obj.Contact : '',
    });
  };

  changeSearchHandler = event => {
    const { allList } = this.state;
    let search_key = event.target.value;
    let filtered= [];
    try {
      if(allList.length > 0 && search_key) {
        filtered = allList.filter(el => (el.Email).toLowerCase().includes(search_key.toLowerCase()) 
              || (el.Name).toLowerCase().includes(search_key.toLowerCase())
              || (el.Contact).toLowerCase().includes(search_key.toLowerCase()));
      } else {
        filtered = allList;
      }
    } catch (err) {} 
    finally {
      this.setState({
        search: search_key,
        userList: filtered
      });
    }
  };

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    if (!this.state.isEdit) {
      const data = {
        session_key: user.session_key,
        email: this.state.email,
      };

      axios
        .post(url + ':3000/v1/user/register', data)
        .then(response => {
          const result = response.data;
          if (result.error == true) {
            this.notificationSystem.addNotification({
              title: <MdClear />,
              message: result.message,
              level: 'error',
              position: 'br',
              autoDismiss: 4,
              dismissible: 'click',
            });
            return;
          }

          this.notificationSystem.addNotification({
            title: <MdDone />,
            message: 'New user added successfully.',
            level: 'success',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          this.setState({ modal: false });
          this.getUserList();
        })
        .catch(error => {
          alert(error);
        });
    } else {
      const data = {
        session_key: user.session_key,
        userId: this.state.userId,
        name: this.state.name,
        contact: this.state.contact,
      };

      axios
        .post(url + ':3000/v1/user/update-profile', data)
        .then(response => {
          const result = response.data;
          if (result.error == true) {
            this.notificationSystem.addNotification({
              title: <MdClear />,
              message: result.message,
              level: 'error',
              position: 'br',
              autoDismiss: 4,
              dismissible: 'click',
            });
            return;
          }

          this.notificationSystem.addNotification({
            title: <MdDone />,
            message: 'User details updated successfully.',
            level: 'success',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          this.setState({ modal: false });
          this.getUserList();
        })
        .catch(error => {
          alert(error);
        });
    }
  };

  delete = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
      ProfileID: this.state.selectedItem,
    };

    axios
      .post(url + ':3000/v1/user/delete', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          return;
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'User deleted successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });
        this.setState({ modal: false, isConfirmDelete: false,
          selectedItem: '', });
        
        this.getUserList();
      })
      .catch(error => {
        alert(error);
      });
  };

  getUserList = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
    };

    axios
      .post(url + ':3000/v1/user/get', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({ userList: result.data, allList: result.data });
      })
      .catch(error => {
        alert(error);
      });
  };

  checkActive(str_datetime) {
    let color = 'green';
    let lastlogin = new Date(str_datetime);
    var current = new Date();
    var hours = Math.abs(current - lastlogin) / (60 * 60 * 1000);
    if (hours <= 24) {
      color = 'green';
    } else if (hours > 24 && hours <= 72) {
      color = 'yellow';
    } else {
      color = 'red';
    }
    return color;
  }

  componentDidMount() {
    this.checkActive();
    const user = StorageService.getSession('user_info');
    if (user.superUser) {
      this.getUserList();
    } else {
      this.setState({
        redirect: true,
      });
    }
  }

  render() {
    const user = StorageService.getSession('user_info');
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    return (
      <Page
        className="Userpage"
        title="Users"
        breadcrumbs={[
          { name: 'Users', active: true, path: '/company/:id/user' },
        ]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between">
                  <Input type="search" placeholder="Search" name="search" value={this.state.search} onChange={this.changeSearchHandler} style={{maxWidth: '250px', marginRight: '8px'}}/>
                  <Button
                    className="theme-button theme-button-primary"
                    onClick={this.toggle('ADD', null)}
                  >
                    Create
                  </Button>
                  </div>
                  <small className="text-muted">Search by Email, Name, and Contact</small>
                <br/><br/>
                <Table responsive hover className="ps-table tb-col-5">
                  <thead>
                    <tr>
                      <th>Email</th>
                      <th>Name</th>
                      <th>Contact</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.userList.length < 1 && (
                      <tr>
                        <td colSpan="4">
                          <div className="ps-empty-data">
                            <div className="empty-content">
                              <MdCreate />
                              <h4>No data to show</h4>
                              <span>
                                Click the 'Create' button to add new user
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}

                    {this.state.userList.length > 0 &&
                      this.state.userList.map((item, index) => {
                        return (
                          <tr
                            key={index}
                            className={
                              user.email === item.Email ? 'active-user' : ''
                            }
                          >
                            <td style={{minWidth: '320px', whiteSpace: 'nowrap', overflow: 'hidden'}}>
                              <div className="online">
                                <Avatar
                                  src={
                                    item.Photo === null || item.Photo === ''
                                      ? userImage
                                      : item.Photo
                                  }
                                />

                                <MdFiberManualRecord
                                  className={
                                    'light ' + this.checkActive(item.LastLogin)
                                  }
                                />
                              </div>{' '}
                              {item.Email}
                            </td>
                            <td>{item.Name}</td>
                            <td>{item.Contact}</td>
                            <td>
                              <div className="ps-action-button">
                                <Button
                                  className="theme-button theme-button-secondary"
                                  onClick={this.toggle('EDIT', item.ProfileID)}
                                >
                                  Edit
                                </Button>
                                {user.email !== item.Email && (
                                  <Button
                                    color="link"
                                    className="theme-button theme-button-primary-light"
                                    onClick={this.confirmDeleteToggle(item.ProfileID)}
                                  >
                                    Delete
                                  </Button>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>

                <ConfirmDeleteModal 
                    action="delete" 
                    name="user"
                    isOpen={this.state.isConfirmDelete}
                    toggle={this.confirmDeleteToggle}
                    actionFunc={this.delete}/>

                <Modal
                  isOpen={this.state.modal}
                  toggle={this.toggle()}
                  className={this.props.className}
                  centered
                >
                  <Form onSubmit={this.handleSubmit} className="AuthForm">
                    <ModalHeader toggle={this.toggle()}>
                      User Information
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col md={12}>
                          <FormGroup>
                            <Label for="email">Email</Label>
                            {this.state.isEdit ? (
                              <p>{this.state.email}</p>
                            ) : (
                              <Input
                                type="email"
                                name="email"
                                value={this.state.email}
                                onChange={this.changeHandler}
                                required
                              />
                            )}
                          </FormGroup>
                          {this.state.isEdit && (
                            <>
                              <FormGroup>
                                <Label for="name">Name</Label>
                                <Input
                                  type="text"
                                  name="name"
                                  value={this.state.name}
                                  onChange={this.changeHandler}
                                  required
                                />
                              </FormGroup>
                              <FormGroup>
                                <Label for="contact">Contact</Label>
                                <Input
                                  type="text"
                                  name="contact"
                                  value={this.state.contact}
                                  onChange={this.changeHandler}
                                />
                              </FormGroup>
                            </>
                          )}
                        </Col>
                      </Row>
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        className="theme-button theme-button-secondary"
                        onClick={this.toggle()}
                      >
                        Close
                      </Button>
                      <Button
                        className="theme-button theme-button-primary"
                        type="submit"
                      >
                        {this.state.isEdit ? 'Save' : 'Add'}
                      </Button>{' '}
                    </ModalFooter>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
    );
  }
}
export default UserPage;
